<template>
  <div class="content-container">
    <div class="table-wrapper">
      <a-table
          :data-source="pageResult"
          :loading="loading"
          :pagination="pagination"
          rowKey="id"
          @change="handleTableChange"
      >

        <a-table-column
            key="id"
            :title="$t('table.contactUs.thead.id')"
            data-index="id"
            align="center"
        >
        </a-table-column>
        <a-table-column
            key="name"
            :title="$t('table.contactUs.thead.name')"
            data-index="name"
            align="center"
        />
        <a-table-column
            key="phone"
            :title="$t('table.contactUs.thead.phone')"
            data-index="phone"
            align="center"
        >
        </a-table-column>
        <a-table-column
            key="industry"
            :title="$t('table.contactUs.thead.industry')"
            data-index="industry"
            align="center"
        >
        </a-table-column>
        <a-table-column
            key="create_time"
            :title="$t('table.contactUs.thead.create_time')"
            data-index="create_time"
            align="center"
        >
        </a-table-column>
        <a-table-column
            key="status"
            :title="$t('table.contactUs.thead.status')"
            data-index="status"
            align="center"
        >
          <template slot-scope="text, record">
            <!-- <span>{{$t(`enum.advStatus.${record.status}`)}}</span> -->
            <a-icon
                v-if="record.status == 0"
                style="color: red"
                type="close"
                @click="updateStatus(record)"
            />
<!--            @click="updateStatus(record)"-->
            <a-icon
                v-else
                style="color: green"
                type="check"
                @click="updateStatus(record)"
            />
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { pageQuery,updateStatus } from "@/api/contact";
export default {
  name: "Contact",
  data() {
    return {
      pageResult: [],
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      this.loading = true;
      pageQuery({
        current_page:this.pagination.current,
        per_page:this.pagination.pageSize
      })
          .then((res) => {
            console.log(res)
            if (res.code === 1) {
              this.loading = false;
              this.pageResult = res.data.data;
              this.pagination.total = res.data.total;
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },
    updateStatus(record) {
      let param = { id: record.id };
      param.status = record.status == 1 ? 0 : 1;
      updateStatus(param).then((res) => {
        this.loadData();
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.loadData();
    },
  }
}
</script>

<style scoped>

</style>
